module.exports = __webpack_public_path__ + "img/sans_gluten.f32719b9.png";